/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */

/**
 * The channel a resend goes out on. String-serialized on the wire.
 */
export type ResendChannel = (typeof ResendChannel)[keyof typeof ResendChannel];

export const ResendChannel = {
  Sms: "Sms",
  Email: "Email",
} as const;
